export const PERFORMANCE_BLOTTER_PREFIX = 'performance/blotter';
export const PERFORMANCE_BLOTTER_TABS_ID = 'portfolio/performance-tabs';
export const ALL_SUB_ACCOUNTS_PLACEHOLDER = 'All Sub Accounts';
